import { useRecoilState } from "recoil";
import { capag } from "../atom";

const useCapagState = () => {
    return useRecoilState(capag);
};

export default useCapagState;